import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch } from "react-redux";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  TextField,
} from "@mui/material";
import { utilityService } from "../../_services";

export default function ModalUpdateMileage(props) {
  // const dispatch = useDispatch();
  const [open, setOpen] = useState(props.open || false);
  const [item, setItem] = useState(props.item || null);
  const [mileage, setMileage] = useState(null);
  const [vin, setVin] = useState(null);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    setItem(props.item);
    if (props.item) {
      setMileage(props.item.mileage);
      setVin(props.item.vehiclevin);
    }
  }, [props.item]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    setOpen(false);
    if (props.onClose) props.onClose();
  };

  const handleUpdate = async () => {
    await utilityService.updateUtility("vehicles", item.id, { mileage });
    setOpen(false);
    handleClose();
  };

  return (
    <Dialog open={open} fullScreen={fullScreen}>
      <DialogTitle id="form-dialog-title" style={{ width: 600 }}>
        Update Mileage for {vin}
      </DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          name={"mileage"}
          label={"Mileage"}
          type="number"
          value={mileage || ""}
          onChange={(event) => setMileage(event.target.value)}
          onWheel={(e) => e.target.blur()}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleUpdate} color="primary">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}
